
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonCheckbox
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';

export default defineComponent({
  name: "DirectSalesDataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonCheckbox
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref<{ [key: string]: any }>({});
    const commercializationTypes = ref([]);
    const selectedCommercializationTypes = ref<number[]>([]);
    const shortSupplyChainTypes = ref([]);
    const selectedShortSupplyChainTypes = ref<number[]>([]);

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating production data:', error);
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      commercializationTypes.value = await getCommercializationTypes();
      selectedCommercializationTypes.value = data.value.commercialization_types || [];
      shortSupplyChainTypes.value = await getShortSupplyChainTypes();
      selectedShortSupplyChainTypes.value = data.value.short_supply_chain_types || [];
      dataLoaded.value = true;
    });

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/direct-sales-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const getCommercializationTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/commercialization-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getShortSupplyChainTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/short-supply-chain-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/direct-sales-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const handleCheckboxChange = (id: number, field: string) => {
      if (field === 'commercialization_types') {
        const index = selectedCommercializationTypes.value.indexOf(id);
        if (index === -1) {
          selectedCommercializationTypes.value.push(id);
        } else {
          selectedCommercializationTypes.value.splice(index, 1);
        }
        data.value[field] = selectedCommercializationTypes.value;
      }
      if (field === 'short_supply_chain_types') {
        const index = selectedShortSupplyChainTypes.value.indexOf(id);
        if (index === -1) {
          selectedShortSupplyChainTypes.value.push(id);
        } else {
          selectedShortSupplyChainTypes.value.splice(index, 1);
        }
        data.value[field] = selectedShortSupplyChainTypes.value;
      }
      updateData(companyId, data.value);
    };

    return {
      translations,
      currentLanguage,
      data,
      commercializationTypes,
      shortSupplyChainTypes,
      selectedCommercializationTypes,
      selectedShortSupplyChainTypes,
      submitForm,
      handleCheckboxChange
    };
  },
});
